/** @format */

import { defineStore } from 'pinia';

export const useResetPasswordStore = defineStore('resetPassword', {
	state: () => ({
		dialogVisible: false,
	}),

	actions: {
		// 显示弹框
		showDialog() {
			this.dialogVisible = true;
		},

		// 隐藏弹框
		hideDialog() {
			this.dialogVisible = false;
		},

		// // 切换弹框状态
		// toggleDialog(visible?: boolean) {
		// 	if (typeof visible === 'boolean') {
		// 		this.dialogVisible = visible;
		// 	} else {
		// 		this.dialogVisible = !this.dialogVisible;
		// 	}
		// },
	},
});

export function useResetPasswordStoreWithOut(): any {
	return useResetPasswordStore();
}
